import React, { Component } from 'react';


class ModalConfirmacionEjecucion extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { data, combosContabilizador, datosCombo, esEjecucionGeneral, nombreProceso, tipoEjecucion } = this.props; 
        let mensaje = "";
        let button = "";
        let buttonCancelar = <button type="button" className="btn btn-secondary" onClick={() => this.props.mostrarOcultarModalContabilizadorRecontabilizador("modalConfirmacionEjecucion", false)} data-dismiss="modal">Cerrar</button>
        let tipoContabilizacion = tipoEjecucion? "Re-contabilización" : "Contabilización"


        const procesoSeleccionado = datosCombo.find((reg) => reg.Nombre === nombreProceso);

        if (this.props.confirmaEjecucion === false) {
            mensaje = <p>Actualmente se encuentra el proceso <strong>{nombreProceso}</strong> en ejecución, aguarde a su finalización para volver a intentarlo</p>;
        } else {
             if (procesoSeleccionado && procesoSeleccionado.ColorUltimaEjecucion === "VERDE") {
                    mensaje = <p>El proceso <strong>{procesoSeleccionado.Nombre}</strong> ya se ha procesado correctamente. ¿Está seguro que desea volver a ejecutarlo?</p>;
            } else {
                    mensaje = <p>¿Está seguro que desea comenzar con el procesamiento?</p>;
            }
            button = <button className="ABMModelosModalContainer__botonAceptar ContabilizadorRecontabilizador__botonConfirmaEjecucion" 
                             onClick={() => esEjecucionGeneral ? this.props.ejecucionLoteContabilidad(this.props.data.datosCombo, this.props.data.barraAvance[0].FechaContabilidadOriginal, data.inputsContabilizadorRecontabilizador.inputFechaContabilidadOriginal, data.inputsContabilizadorRecontabilizador.modalSeleccionModelos.modelosContablesSeleccionados, !data.radioButtonsContabilizador.contabilizacion, data.combosContabilizador.comboProceso, tipoEjecucion) : this.props.ejecucionIndividual(this.props.nombreProceso, this.props.data)}>Confirmar</button>;
        }
        if(this.props.data.muestraMensajeErrorEjecucion){
            mensaje = <p>Hubo un error durante el procesamiento, no fue posible concretar la <strong>{tipoContabilizacion}</strong>. Comuníquese con soporte para más información.</p>;
        }
        
        return (
            <div className='modalContainer'>
                <div className="modalDemandaOutXS">
                    <div className="modal-content">
                        <div className="modal-header ContabilizadorRecontabilizador__modal-ejecucion-header">
                            <div className="close" data-dismiss="modal" aria-hidden="true">
                                <label onClick={() => this.props.mostrarOcultarModalContabilizadorRecontabilizador("modalConfirmacionEjecucion", false)} className="ti-close clickable"></label>
                            </div>
                            <h3 className="modal-title">Contabilizador / Re-contabilizador</h3>
                        </div>

                        <div className="modal-body">{mensaje}</div>
                        <div className="modal-footer"> <div className="row">        
                        <div className="col-xs-12">
                            {buttonCancelar}
                            {button}
                        </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalConfirmacionEjecucion;   